import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { loadEntitiesFullListComponent } from 'store/actions/entities/entitiesActions';
import { Typography, Grid, Chip, Avatar, Button, Box, Tooltip, } from '@mic3/platform-ui';
import { closeFilterbar } from 'store/actions/filterbar/filterbarActions';
import Icon from 'app/components/atoms/Icon/Icon';
import { muiTheme } from 'app/themes/materialUi';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import Ellipsis from 'app/components/molecules/Ellipsis/Ellipsis';
import { getAttachmentUrl } from 'app/utils/attachments/attachmentsUtils';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { evaluateProperty } from 'app/utils/designer/form/fieldUtils';
import EntityListAttributeModal from 'app/containers/Designer/Form/components/EntityListAttribute/EntityListAttributeModal'

const MoreChipStyled = styled(Chip)`
    background: ${({ theme }) => theme.material.colors.background.fields} !important;


`;
const StyledChip = styled(Chip)`
    background-color:  ${({ theme }) => theme.material.colors.background.chips} !important;
    &.MuiChip-clickable:hover,
    &.MuiChip-clickable:focus{
        background-color: ${({ theme }) => theme.material.colors.background.hover} !important;
    }
`;
const ChipsWrapper = styled.div`
    & .MuiChip-root{
        max-width: 140px !important;
    }
`;

const ChipsShortWrapper = styled.div`
    & .MuiChip-root{
        max-width: 140px !important;
        margin-right: 4px;
        margin-bottom: 4px;
    }
`;

const StyledButton = styled(Button)`
    &.MuiButton-root {
    min-width: 40px !important;
    height: 40px;
    }
`;

class EntityListAttribute extends PureComponent {

    constructor(props) {
        super(props);
        props.isDynamicList && this.loadEntitiesShortList();
        this.state = {
            isOpenEntitiesModal: false,
            shortList: [],
        };
    }

    @bind
    openEntitiesModal() {
        this.setState({ isOpenEntitiesModal: true });
    }
    @bind
    closeEntitiesModal() {
        this.props.closeFilterbar();
        this.setState({ isOpenEntitiesModal: false });
    }

    @bind
    normilizedFilterBy(filterEntitiesBy) {
        const normalize = (node) => {
            if (Array.isArray(node)) {
                return node.map(normalize);
            } else if (typeof node === 'object' && node !== null) {
                const filterNode = {};
                for (const [key, value] of Object.entries(node)) {
                    if (key === 'value') {
                        if (Array.isArray(value)) {
                            const parsedValues = value.flatMap(item => {
                                if (typeof item === 'string' && item.includes('{{') && item.includes('}}')) {
                                    const evaluated = evaluateProperty({ ...this.props, value: item }, 'value');
                                    const evaluatedValue = evaluated.value;

                                    if (Array.isArray(evaluatedValue)) {
                                        return evaluatedValue;
                                    }
                                    return evaluatedValue;
                                }
                                return item;
                            });

                            filterNode[key] = parsedValues;
                        } else {
                            const evaluated = evaluateProperty({ ...this.props, value }, 'value');
                            filterNode[key] = evaluated.value;
                        }
                    } else {
                        filterNode[key] = normalize(value);
                    }
                }
                return filterNode;
            }
            return node;
        };

        const normalizedFilters = normalize(filterEntitiesBy);
        return normalizedFilters;
    }



    @bind
    async loadEntitiesShortList() {
        const { entityType, loadEntitiesFullListComponent, filterEntitiesBy, isDynamicList, isSidebar } = this.props
        if (!isDynamicList) return;
        const stopIndex = isMobile || isSidebar ? 2 : 4;
        const result = await loadEntitiesFullListComponent({
            options: {
                filterBy: this.normilizedFilterBy(filterEntitiesBy),
                startIndex: 0,
                stopIndex: stopIndex,
            },
            type: entityType?.uri,
        });
        this.setState({ shortList: result })
    }

    render() {
        const {
            value, disabled, label, entityType, filterEntitiesBy, name,
            actions, entityAttributes, onMouseDown, relatedEntityDefinition, isSidebar, isDynamicList, context, details
        } = this.props;
        const { shortList } = this.state
        const maxVisible = isMobile || isSidebar ? 3 : 5;
        const listValue = !isDynamicList ? value : [];

        return (
            <Box>
                <Typography variant="button">{label}</Typography>
                <Grid container wrap="nowrap" alignItems='center'>
                    {isDynamicList ? <ChipsShortWrapper>
                        {shortList?.records?.map(({ name, id, image, type }) => {
                            const imgType = type || 'user'
                            const avatarImg = image ? getAttachmentUrl(id, imgType, image) : null;
                            return (
                                <Tooltip key={id} title={name} placement='top'>
                                    <StyledChip
                                        key={id}
                                        disabled={disabled}
                                        label={name}
                                        avatar={<Avatar alt={name} src={avatarImg} initials={name} />}
                                        onClick={this.openEntitiesModal}
                                    />
                                </Tooltip>
                            );
                        })}
                        {shortList?.count > maxVisible && (
                            <MoreChipStyled
                                variant="default"
                                label={`+${shortList.count - maxVisible}`}
                                size="small"
                                onClick={this.openEntitiesModal}
                                disabled={disabled}
                            />
                        )}
                    </ChipsShortWrapper> :
                        <>
                            <StyledButton variant="text" disabled={disabled} onClick={this.openEntitiesModal}>
                                <Icon name="plus" hexColor={muiTheme.colors.text.buttonActive} />
                                {!value?.length ? 'ADD NEW' : null}
                            </StyledButton>
                            <ChipsWrapper>
                                <Ellipsis
                                    data={value || []}
                                    displaySize={maxVisible}
                                    style={{ maxWidth: '140px' }}
                                    renderCount={count => (
                                        <MoreChipStyled
                                            variant="default"
                                            label={`+${count}`}
                                            size="small"
                                            onClick={this.openEntitiesModal}
                                            disabled={disabled}
                                        />
                                    )}
                                    renderItem={({ name, id, image, type }) => {
                                        const imgType = type || 'user'
                                        const avatarImg = image ? getAttachmentUrl(id, imgType, image) : null;
                                        return (
                                            <Tooltip key={id} title={name} placement='top'>
                                                <StyledChip
                                                    disabled={disabled}
                                                    label={name}
                                                    avatar={<Avatar alt={name} src={avatarImg} initials={name} />}
                                                    onClick={this.openEntitiesModal} />
                                            </Tooltip>
                                        );
                                    }}
                                />
                            </ChipsWrapper>
                        </>
                    }
                </Grid>
                {this.state.isOpenEntitiesModal && (
                    <EntityListAttributeModal
                        onClose={this.closeEntitiesModal}
                        onApply={this.props.onChange}
                        type={entityType.uri}
                        label={label}
                        filterEntitiesBy={this.normilizedFilterBy(filterEntitiesBy)}
                        name={name}
                        value={listValue}
                        actions={actions}
                        entityAttributes={entityAttributes}
                        onMouseDown={onMouseDown}
                        isSidebar={isSidebar}
                        relatedEntityDefinition={relatedEntityDefinition}
                        isDynamicList={isDynamicList}
                        context={context}
                        details={details}
                        loadEntitiesShortList={this.loadEntitiesShortList}
                    />
                )}
            </Box>)
    }
}


export default connect(null, { closeFilterbar, loadEntitiesFullListComponent })(EntityListAttribute);
